import SupportContacts from '~/core/components/SupportContacts/SupportContacts.vue';
import BaseBottomSheet from '~/core/components/Base/BaseBottomSheet.vue';
export default defineComponent({
  name: 'SupportContactsBottomSheet',
  components: {
    BaseBottomSheet: BaseBottomSheet,
    SupportContacts: SupportContacts
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    support: {
      type: Object,
      required: true
    }
  }
});